<template>
    <div id="bene-basic-2-container">
        <f7-list form class="form-group">
            <f7-list-input
                input-id     ="bankAccountNo"
                name         ="bankAccountNo"
                type         ="text"

                v-if         ="showFormInput.root.bankAccountNo"
                :label       ="bankAccountNoLabel"
                :placeholder ="bankAccountNoLabel"
                :value       ="bankAccountNo"
                @change      ="setBankAccountNo($event.target.value); validateInput($event.target); setInput($event.target)"

                maxlength    ="30"
                autocomplete ="off"
                outline
                floating-label
                clear-button
            ></f7-list-input>

            <f7-list-input
              id            ="walletNo"
              input-id      ="walletNo"
              name          ="walletNo"
              type          ="tel"
              class         ="mobile-input"
              :label        ="$t('beneficiary-mobile-topup-no')"
              :placeholder  ="$t('beneficiary-mobile-topup-no')"
              :value        ="walletNo"
              @change       ="setWalletNo($event.target.value); validateInput($event.target); setInput($event.target)"
              v-show        ="showFormInput.root.walletNo"
              maxlength    ="30"
              autocomplete ="off"
              outline
              floating-label
              clear-button
            >
              <f7-link popover-open=".popover-mobile-no" slot="content-start" style="pointer-events: none; cursor: default" class="" readonly>
                <img :src="getFlagImg(homeCountryId)" class="" />
                <span class="">{{ homeCountryIdd }}</span>
              </f7-link>
            </f7-list-input>

            <f7-list-input
                input-id     ="cnIdentificationNo"
                name         ="cnIdentificationNo"
                type         ="text"

                v-if         ="showFormInput.root.cnIdentificationNo"
                :label       ="$t('beneficiary-beneficiary-id-no')"
                :placeholder ="$t('beneficiary-beneficiary-id-no')"
                :value       ="identificationNo"
                @change      ="setIdentificationNo($event.target.value); validateInput($event.target); setInput($event.target)"

                maxlength    ="30"
                autocomplete ="off"
                outline
                floating-label
                clear-button
            ></f7-list-input>

            <f7-list-input
                input-id     ="dateOfBirth"
                name         ="dateOfBirth"
                type         ="text"

                v-if         ="showFormInput.root.dob"
                :label       ="$t('beneficiary-beneficiary-dob')"
                :placeholder ="$t('beneficiary-beneficiary-dob')"
                :value       ="dateOfBirth"
                @change      ="setDateOfBirth($event.target.value); validateInput($event.target); setInput($event.target)"

                maxlength    ="10"
                outline
                floating-label
            ></f7-list-input>

            <f7-list-input
                input-id     ="philGovServiceFullname"
                name         ="philGovServiceFullname"
                type         ="text"

                v-if         ="showFormInput.root.philGovServiceFullname"
                :label       ="$t('beneficiary-fullname')"
                :placeholder ="$t('beneficiary-fullname')"
                :value       ="beneficiaryName"
                @change      ="setBeneficiaryName($event.target.value); validateInput($event.target); setInput($event.target)"

                maxlength    ="100"
                autocomplete ="off"
                outline
                floating-label
                clear-button
            ></f7-list-input>

            <f7-list-input
                input-id     ="philGovServiceNickname"
                name         ="philGovServiceNickname"
                type         ="text"

                v-if         ="showFormInput.root.philGovServiceNickname"
                :label       ="$t('beneficiary-nickname')"
                :placeholder ="$t('beneficiary-nickname')"
                :value       ="nickname"
                @change      ="setNickname($event.target.value); validateInput($event.target); setInput($event.target)"

                maxlength    ="100"
                autocomplete ="off"
                outline
                floating-label
                clear-button
            ></f7-list-input>

            <f7-list-input
                input-id     ="philGovMemberType"
                id           ="philGovMemberTypeInput"
                name         ="philGovMemberType"
                class        ="clickable-row use-chevron"

                v-if         ="showFormInput.root.philGovServiceMemberType"
                :label       ="$t('beneficiary-phil-gov-member-type')"
                :placeholder ="$t('beneficiary-phil-gov-member-type')"
                :value       ="philGovMemberType"
                @change      ="changePhilGovMemberType($event.target.value);"

                outline
                floating-label
            >
                <f7-link popover-open=".popover-dropdown-philgov-member-type" slot="content-start" class="clickable-item"></f7-link>
            </f7-list-input>

            <f7-popover id="dropdownPhilGovMemberType" class="popover-dropdown-philgov-member-type dropdown-default dropdown beneficiary" :backdrop="true">
                <f7-list>
                    <f7-list-item popover-close link="#"
                    v-for="mt in philGovMemberTypeList" v-show="(bankId != 4522) || (bankId == 4522 && mt.id != 2)"
                    :key="mt.id"
                    selected=""
                    @click="changePhilGovMemberType(mt.id); validateInput($event.target); setInput('philGovMemberType')">
                        {{mt.name}}
                    </f7-list-item>
                </f7-list>
            </f7-popover>

            <f7-list-input
                input-id     ="refNo"
                name         ="refNo"
                type         ="text"

                v-if         ="showFormInput.root.refNo"
                :label       ="refNoLabel"
                :placeholder ="refNoLabel"
                :value       ="refNo"
                @change      ="setRefNo($event.target.value); validateInput($event.target); setInput($event.target)"

                maxlength    ="50"
                autocomplete ="off"
                outline
                floating-label
                clear-button
            ></f7-list-input>
        </f7-list>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from "vuex";
    export default {
        props: {
        },
        mounted() {
            this.init();
        },
        data: function() {
            return {}
        },
        computed: {
            ...mapGetters('beneficiary', [
                'showFormSet',
                'showFormInput',
                'bankAccountNoLabel',
                'bankAccountNo',
                'identificationNo',
                'dateOfBirth',
                'beneficiaryName',
                'nickname',
                'philGovMemberType',
                'philGovMemberTypeId',
                'philGovMemberTypeList',
                'refNoLabel',
                'refNo',
                'bankId',
                'mobileIDD',
                'mobileIDDCode',
                'walletNo',
                'homeCountryId',
                'homeCountryIdd'
            ])
        },
        methods: {
            ...mapActions('beneficiary', [
                'setBankAccountNo',
                'setIdentificationNo',
                'setDateOfBirth',
                'setPhilGovMemberType',
                'setBeneficiaryName',
                'setNickname',
                'setRefNo',
                'setWalletNo',
            ]),

            async init() {
                const self    = this;
                const popover = ".beneficiary.popover-dropdown-philgov-member-type";
                const popoverInner = ".beneficiary.popover-dropdown-philgov-member-type .popover-inner";
                const popoverId = "dropdownPhilGovMemberType";
                const inputId = "philGovMemberType";
                const inputListId = "#philGovMemberTypeInput";
                await self.setDropdownDirection(popover, popoverInner, popoverId, inputId, inputListId)
            },

            changePhilGovMemberType(id) {
                this.$emit("changePhilGovMemberType", id);
            },

            validateInput(inputEl) {
                this.$emit("validateInput", inputEl);
            },

            setInput(inputEl) {
                this.$emit("setInput", inputEl);
            }
        }
    }
</script>